import React, { useState, useRef, useEffect } from 'react';

const OTPInput = ({ length = 6, onChange, value = '' }) => {
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (value && value.length <= length) {
      const newOtp = value.split('').concat(new Array(length - value.length).fill(''));
      setOtp(newOtp);
    } else if (!value) {
      setOtp(new Array(length).fill(''));
    }
  }, [value, length]);

  // Focus first input on component mount
  useEffect(() => {
    if (inputRefs.current[0]) {
      setTimeout(() => {
        inputRefs.current[0].focus();
      }, 100);
    }
  }, []);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Join all digits and call onChange
    const otpValue = newOtp.join('');
    if (onChange) {
      onChange(otpValue);
    }

    // Focus next input
    if (element.value && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otp];
      
      if (otp[index]) {
        // If current box has value, clear it
        newOtp[index] = '';
        setOtp(newOtp);
        const otpValue = newOtp.join('');
        if (onChange) {
          onChange(otpValue);
        }
      } else if (index > 0) {
        // If current box is empty, move to previous and clear it
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1].focus();
        const otpValue = newOtp.join('');
        if (onChange) {
          onChange(otpValue);
        }
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === 'ArrowRight' && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text');
    const pasteArray = pasteData.slice(0, length).split('');
    
    if (pasteArray.every(char => !isNaN(char) && char !== '')) {
      const newOtp = [...pasteArray, ...new Array(length - pasteArray.length).fill('')];
      setOtp(newOtp);
      
      const otpValue = newOtp.join('');
      if (onChange) {
        onChange(otpValue);
      }
      
      // Focus the next empty input or the last input
      const nextIndex = Math.min(pasteArray.length, length - 1);
      inputRefs.current[nextIndex].focus();
    }
  };

  return (
    <div className="wa-otp-container">
      {otp.map((data, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={data}
          className={`wa-otp-input-box ${data ? 'filled' : ''}`}
          ref={(ref) => (inputRefs.current[index] = ref)}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          onFocus={(e) => e.target.select()}
        />
      ))}
    </div>
  );
};

export default OTPInput;
